import { FC, useEffect, useState } from 'react';
import '../EditAlternativePassportData/EditAlternativePassportData.scss';

import Button from 'components/common/ui-kit/Button';
import { InputV2 } from 'components/common/ui-kit/Input/view';
import useAppDispatch from 'hooks/common/useAppDispatch';
import useAppSelector from 'hooks/common/useAppSelector';
import { User } from 'models/enrollee';
import { hideModal } from 'redux/actions';
import { enrolleesApi } from 'redux/api/questionnaire/enrollees-api';
import { useUpdateLatinFioMutation } from 'redux/api/questionnaire/questionnaire-api';
import {
  selectCurrentApplication,
  selectCurrentQuestionnaire,
} from 'redux/selectors/staff/applications';
import { staffApplicationsSlice } from 'redux/slices/staff/staffApplicationsSlice';
import { supportQuestionnaireSlice } from 'redux/slices/staff/supportQuestionnaireSlice';

import TemplateModal from '../TemplateModal';

const EditLatinFio: FC = () => {
  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(hideModal());
  const { isSupport } = useAppSelector(state => state.modal.data) || {};

  const questionnaire = useAppSelector(selectCurrentQuestionnaire);
  const application = useAppSelector(selectCurrentApplication);

  const [updateLatinFio, { isLoading }] = useUpdateLatinFioMutation();
  const [triggerGetEnrollee] = enrolleesApi.useLazyGetByUserIdQuery();

  const userId = questionnaire?.user.id;

  const [surnameLatin, setLastName] = useState('');
  const [nameLatin, setFirstName] = useState('');
  const [patronymicLatin, setMiddleName] = useState('');

  const editingData = questionnaire?.generalDataForm;

  useEffect(() => {
    if (editingData) {
      setLastName(editingData.surnameLatin || '');
      setFirstName(editingData.nameLatin || '');
      setMiddleName(editingData.patronymicLatin || '');
    }
  }, [editingData]);
  const isInvalid = (value: string) => /[^A-Za-z\s-]/.test(value);
  const handleLatinChange = (value: string, setter: (val: string) => void) => {
    const latinOnly = value.replace(/[^A-Za-z\s-]/g, '');
    setter(latinOnly);
  };

  const handleSave = async () => {
    if (!userId) {
      return;
    }

    try {
      await updateLatinFio({
        userId,
        surnameLatin,
        nameLatin,
        patronymicLatin,
      }).unwrap();

      const freshQuestionnaire = await triggerGetEnrollee(userId).unwrap();

      if (isSupport) {
        dispatch(
          supportQuestionnaireSlice.actions.setCurrentQuestionnaire(
            freshQuestionnaire
          )
        );
      } else {
        dispatch(
          staffApplicationsSlice.actions.setCurrentApplication({
            application: application!,
            questionnaire: freshQuestionnaire,
            user: userId ? ({ id: userId } as User) : undefined,
          })
        );
      }
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <TemplateModal title="Редактировать ФИО">
      <div className="passport-data-modal">
        <div className="passport-group">
          <label>Фамилия:</label>
          <InputV2
            type="string"
            value={surnameLatin}
            onChange={e => handleLatinChange(e.target.value, setLastName)}
            error={
              isInvalid(surnameLatin) ? 'Допустима только латиница' : undefined
            }
          />

          <label>Имя:</label>
          <InputV2
            type="string"
            value={nameLatin}
            onChange={e => handleLatinChange(e.target.value, setFirstName)}
            error={
              isInvalid(nameLatin) ? 'Допустима только латиница' : undefined
            }
          />

          <label>Отчество:</label>
          <InputV2
            type="string"
            value={patronymicLatin}
            onChange={e => handleLatinChange(e.target.value, setMiddleName)}
            error={
              isInvalid(patronymicLatin)
                ? 'Допустима только латиница'
                : undefined
            }
          />
        </div>
        <div className="action">
          <Button theme="success" onClick={handleSave} disabled={isLoading}>
            {isLoading ? 'Сохранение...' : 'Сохранить'}
          </Button>
        </div>
      </div>
    </TemplateModal>
  );
};

export default EditLatinFio;
